<ion-content class="oe-tartalom">
  <div class="oe-doboz">
    <h1>Okirat ellenőrzése</h1>
    <p class="oe-bevezeto">
      A kiállított digitális bizonyítvány alján található egyedi azonosítóval ellenőrizhető, hogy az okiratot
      a tanulmányi rendszerben valóban kiállították-e, és azóta nem vonták-e vissza (Nkt. 57. § (6a)–(6b)).
      Személyes adatot ez az oldal nem mutat – azokat maga az okirat tartalmazza.
    </p>

    <form class="oe-urlap" (ngSubmit)="ellenoriz()">
      <ion-input
        fill="outline"
        label="Egyedi azonosító"
        label-placement="stacked"
        name="azonosito"
        [(ngModel)]="azonosito"
        placeholder="pl. 3f2b6c1e-8a4d-4c2e-9b1a-7d5e6f8a9b0c"
        autocomplete="off"
        [clearInput]="true"
      ></ion-input>
      <ion-button type="submit" [disabled]="fut || !azonosito.trim() || diszpeldanyKod">
        <ion-icon slot="start" name="shield-checkmark-outline"></ion-icon>Ellenőrzés
      </ion-button>
    </form>

    <!-- A díszpéldány (papír alapú hiteles másolat) saját azonosítója a díszpéldány-ellenőrzőhöz tartozik. -->
    <ion-note *ngIf="diszpeldanyKod" class="oe-megjegyzes" color="medium">
      Ez egy díszpéldány-azonosító (DP-…). A díszpéldányt a
      <a [href]="diszpeldanyUrl">díszpéldány-ellenőrző oldalon</a> lehet ellenőrizni.
    </ion-note>

    <div *ngIf="fut" class="oe-tolt"><ion-spinner name="crescent"></ion-spinner></div>

    <ion-note *ngIf="hiba && !fut" color="danger" class="oe-megjegyzes">{{ hiba }}</ion-note>

    <ng-container *ngIf="eredmeny && !fut">
      <div *ngIf="!eredmeny.talalt" class="oe-sav oe-sav--nincs">
        <ion-icon name="help-circle-outline" aria-hidden="true"></ion-icon>
        <div>
          <b>Nincs ilyen okirat a nyilvántartásban.</b>
          <p>{{ eredmeny.uzenet || 'Ellenőrizd a begépelt azonosítót.' }}</p>
        </div>
      </div>

      <ng-container *ngIf="eredmeny.talalt">
        <div class="oe-sav" [class.oe-sav--jo]="allapotSzin === 'success'" [class.oe-sav--rossz]="allapotSzin === 'danger'"
             [class.oe-sav--figyel]="allapotSzin === 'warning'">
          <ion-icon [name]="allapotSzin === 'success' ? 'checkmark-circle-outline' : (allapotSzin === 'danger' ? 'close-circle-outline' : 'alert-circle-outline')"
                    aria-hidden="true"></ion-icon>
          <div><b>{{ allapotSzoveg }}</b></div>
        </div>

        <ion-list lines="full" class="oe-lista">
          <ion-item>
            <ion-label class="ion-text-wrap"><p>Okirat</p><h3>{{ eredmeny.tipus_nev }}<ng-container *ngIf="eredmeny.tanev">, {{ eredmeny.tanev }}. tanév</ng-container></h3></ion-label>
          </ion-item>
          <ion-item>
            <ion-label class="ion-text-wrap">
              <p>Kiállító intézmény</p>
              <h3>{{ eredmeny.intezmeny?.nev || '–' }}<ng-container *ngIf="eredmeny.intezmeny?.om"> (OM: {{ eredmeny.intezmeny?.om }})</ng-container></h3>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label class="ion-text-wrap"><p>Kiállítás napja</p><h3>{{ datum(eredmeny.kiallitva) }}</h3></ion-label>
          </ion-item>
          <ion-item>
            <ion-label class="ion-text-wrap"><p>Elektronikus aláírás</p><h3>{{ eredmeny.alairt ? 'Aláírt' : 'Nincs aláírva' }}</h3></ion-label>
          </ion-item>
          <ion-item>
            <ion-label class="ion-text-wrap"><p>Időbélyeg</p><h3>{{ idobelyegSzoveg }}</h3></ion-label>
          </ion-item>
          <ion-item>
            <ion-label class="ion-text-wrap"><p>Időbélyeg-felülhitelesítés</p><h3>{{ felulhitelesitesSzoveg }}</h3></ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-label class="ion-text-wrap"><p>Egyedi azonosító</p><h3 class="oe-kod">{{ eredmeny.azonosito }}</h3></ion-label>
          </ion-item>
        </ion-list>

        <p class="oe-labjegyzet">
          Az okirat tartalmának egyezését a PDF elektronikus aláírása igazolja: nyisd meg a fájlt egy aláírást
          ellenőrző PDF-olvasóban. Ez az oldal azt igazolja, hogy ilyen azonosítóval okiratot állítottak ki.
        </p>
      </ng-container>
    </ng-container>
  </div>
</ion-content>
